import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { OVERLAY_SIZES } from "../../constants";
import FocusTrap from 'focus-trap-react';

export default class Overlay extends Component {
    static propTypes = {
        title: PropTypes.string,
        children: PropTypes.any,
        closeOverlay: PropTypes.func.isRequired,
        className: PropTypes.string,
        size: PropTypes.oneOf(Object.keys(OVERLAY_SIZES).map(e => OVERLAY_SIZES[e]))
    }

    constructor(props) {
        super(props);

        this.handlerEscape = this.handlerEscape.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    static defaultProps = {
        title: "Overlay Title",
        size: OVERLAY_SIZES.M
    }

    componentDidMount() {
        document.body.classList.add('disable-body-scroll');
        document.addEventListener('click', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.body.classList.remove('disable-body-scroll');
        document.removeEventListener('click', this.handleClickOutside);
    }

    handlerEscape(event) {
        if (event.key == "Escape" || event.key == "Esc" || event.keyCode == 27)
            this.props.closeOverlay();
    }

    handleClickOutside(event) {
        if(event.target === this.refs.outsideOfModal.node )
            this.props.closeOverlay();
    }

    render() {
        return (
            <FocusTrap ref="outsideOfModal" className={`overlay ${this.props.className} overlay-size-${this.props.size}`}>
                <div className="overlay__wrap" onKeyDown={this.handlerEscape} onClick={this.handleClickOutside} tabIndex="0">
                    <div className="overlay__header no-print">
                        { this.props.title }
                        <div className="la-CloseRemove" onClick={this.props.closeOverlay}/>
                    </div>
                    <div className="overlay__content">
                        {this.props.children}
                    </div>
                </div>
            </FocusTrap>
        )
    }
}


// WEBPACK FOOTER //
// ./src/scripts/reusable/Overlays/Overlay.jsx